import { isTransform, asTransformCssVar, transformAlias } from './transforms.es.js';

function getStyleName(key) {
    if (transformAlias[key])
        key = transformAlias[key];
    return isTransform(key) ? asTransformCssVar(key) : key;
}

export { getStyleName };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/animate/utils/get-style-name.es.js
// module id = za+D
// module chunks = 0